import React from 'react';
import styles from './RegistrationTypeCard.module.scss';

const RegistrationTypeCard = ({ children, onClick, isSelected }) => {
  return (
    <div
      className={`${styles.card} ${isSelected ? styles.selected : ''}`}
      onClick={onClick}
    >
      {children}
    </div>
  );
};

export default RegistrationTypeCard;
